import { makeStyles } from '@fluentui/react-components';

export const NestedSelectorStyles = makeStyles({
  menuPopover: {
    maxHeight: '40rem',
  },
});
